/** product page table switch **/
function test_ready(fn){
    if(document.addEventListener){
            document.addEventListener('DOMContentLoaded',function(){
                document.removeEventListener('DOMContentLoaded',arguments.callee,false);
                fn();
            },false);
     }else if(document.attachEvent){
          document.attachEvent('onreadystatechange',function(){
               if(document.readyState=='complete'){
                    document.detachEvent('onreadystatechange',arguments.callee);
                    fn();
               }
          });
    }
}

test_ready(() => {
//  window.addEventListener('load', function() {
      jQuery('.product-description .tabs.ymq_pc_show li').click(function(){
        jQuery('.product-description .tabs li').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.tabs-content-item').removeClass('active');
        jQuery('.'+jQuery(this).data('tab')).addClass('active');
      })
      $('.product-description .tabs.ymq_m_show').click(function(){
      
        let isOpen = $(this).attr("data-open")
        let groupIndex = $(this).attr("data-groups")
        if(isOpen === "true"){
          $(this).attr("data-open","false").find("li").removeClass("active")
          $(`.tabs-content-item[data-groups="${groupIndex}"]`).removeClass("active")
        }else{
          $(this).attr("data-open","true").find("li").addClass("active")
          $(`.tabs-content-item[data-groups="${groupIndex}"]`).addClass("active")
        }
      }) 
    // $('.downloads-tab,.accessorie-tab').click();
    // $('.downloads-tab,.accessorie-tab').click().removeClass('active');

    /*product page content compare */
    $(".compare-subhead").click(function(){
      if($(this).hasClass('active')){
        $(this).removeClass("active");
        $(this).next(".compare-content").css("display","none")
      }else{
        $(this).addClass("active");
        $(this).next(".compare-content").css("display","block")
      }
    });
  });

  
/** product page table switch end**/

/**product page trust info popups**/
  function closeTxtModal() {
    $('#txtModal').hide();
  }

  function openTxtModal(con) {
    $('#txtModal').show();
    $('#txtModal_con').html(con);
  }

  window.addEventListener('load', function() {
    const modalData = [
      {
        key: 0,
        title: 'Free Shipping & No Extra Tax',
        content: '<p>We offer free shipping straight to your door throughout the contiguous US*. It usually takes 3-5 days for your package to be delivered, so you can sit back and relax, worry-free.</p><p>*We have warehouse located at California and New Jersey, US.</p><p>*Please see our shipping policy for more details.</p>'
      },
      {
        key: 1,
        title: '30-Day Return or Replacement',
        content: '<p>Get a full refund when you return your undamaged products <b>within 30 days - for any reason</b>. Once the item arrives back at our warehouse for inspection, the refund process will begin.</p><p>See our refund policy for more details about what is needed for a smooth refund process.</p>'
      },
      {
        key: 2,
        title: 'Hassle-Free Warranty',
        content: '<p>OBDPRICE provides a straightforward, hassle-free warranty to save you some headaches. If you have any question about the warranty, feel free to contact us at sales@obdprice.com.</p>'
      },
      {
        key: 3,
        title: 'Lifetime Customer Support',
        content: '<p>We\'ll always be there for you. If you have any questions or concerns, feel free to contact us at sales@obdprice.com.</p>'
      }
    ];

    $('.openTxtModal').click(function() {
      const modalKey = $(this).data('key');
      const modalTitle = modalData[modalKey].title;
      const modalContent = modalData[modalKey].content;
      openTxtModal(`<div class="title">${modalTitle}</div><div class="txtCon">${modalContent}</div>`);
    });
  });
/**product page trust info popups end**/

 // ***************************************************
// 创建一个表示当前本地日期和时间的 Date 对象
const currentDate = new Date();
// 1 天的毫秒数为 24 * 60 * 60 * 1000
const threeDaysLater = new Date(currentDate.getTime() + (3 * 24 * 60 * 60 * 1000));
const fiveDaysLater = new Date(currentDate.getTime() + (5 * 24 * 60 * 60 * 1000));
const sevenDaysLater = new Date(currentDate.getTime() + (7 * 24 * 60 * 60 * 1000));
const tenDaysLater = new Date(currentDate.getTime() + (10 * 24 * 60 * 60 * 1000));
const options = {
    // year: 'numeric',
    month: 'short',
    day: 'numeric'
};

// 使用 Intl.DateTimeFormat 进行日期格式化
const formatter = new Intl.DateTimeFormat('en-US', options);
// 对日期进行格式化
const threeFormattedDate = formatter.format(threeDaysLater);
const fiveFormattedDate = formatter.format(fiveDaysLater);
const sevenFormattedDate = formatter.format(sevenDaysLater);
const tenFormattedDate = formatter.format(tenDaysLater);
// ***************************************************

let abbreviation = '';
let fullName = '';
// 获取国家ip
function getUserCountry() {
  fetch('https://ipinfo.io/json')
    .then(response => response.json())
    .then(data => {
      abbreviation = data.country

      // 如果US则展示USA
      if(abbreviation == 'US'){
        fullName = 'USA'
        $(".buyMe_early_dates").text(threeFormattedDate)
        $(".buyMe_late_dates").text(fiveFormattedDate)
      }else{
        // 如果匹配到其他国家则展示对应国家全称 否则 展示USA
        let isFullName = convertAbbreviationToFullName(abbreviation);
        if(isFullName=="false"){
          fullName = 'USA'
          $(".buyMe_early_dates").text(threeFormattedDate)
          $(".buyMe_late_dates").text(fiveFormattedDate)
        }else{
          fullName = isFullName
          $(".buyMe_early_dates").text(sevenFormattedDate)
          $(".buyMe_late_dates").text(tenFormattedDate)
        }
      }
      if($(".buyMe")){
        $(".buyMe-left h6 span").text(fullName)
      }
    })
    .catch(error => console.error('Error:', error));
}


function getBuyMePrice(){
  setTimeout(() => {
    let buyMe_price = $(".product-details .product__price .price__current .money").text()
    let buyMe_original_price = $(".product-details .product__price .price__compare-at.visible .price__compare-at--single").text()

    // 促销折扣价
    let changeBuyMePrice = (Number(buyMe_price.replace("$","").replaceAll(",",""))*0.92).toFixed(2)
    $(".buyMe .price__current .money").text(changeBuyMePrice)
    $(".buyMe .price__current .original_price").text(buyMe_price)
    // if(buyMe_original_price && buyMe_original_price!=''){
    //   $(".buyMe .price__current .original_price").text(buyMe_original_price)
    // }else{
    //     $(".buyMe .price__current .original_price").text('')
    // }
  }, 500);
}




window.addEventListener('load', function() {
  getUserCountry(); // 调用函数
  getBuyMePrice()
  $("variant-selection .options-selection__option-value-input + .options-selection__option-value-name").click(function(){
    getBuyMePrice()
  })


// 首屏不显示，下滑显示 start
 let elementTopfixed = $('.product_livechat').offset().top
   $(window).on('scroll', function() {
      var windowTop = $(window).scrollTop(); 
      if (window.screen.width > 1024) {
        if(windowTop >= elementTopfixed+80){
          $(".buyMe").show()
        }
        if(windowTop < elementTopfixed+80){
            $(".buyMe").hide()
        }
      }else{
        if(windowTop >= elementTopfixed+120){
          $(".buyMe").show()
        }
        if(windowTop < elementTopfixed+120){
            $(".buyMe").hide()
        }
      }
  });
  // end


  if(localStorage.getItem('buyMeCart')){
    localStorage.removeItem('buyMeCart');
  }
  // buynow 点击
  $(".buyMe .atc-button").click(function(){
    localStorage.setItem('buyMeCart', 'true');
    $(".product-form-add-to-cart input.add-to-cart-button").click()
  })



  localStorage.removeItem('buyMeCart');
  // buy me add to cart 按钮点击
  $(".buyMe .cs-product-atc span").click(function(){
    localStorage.setItem('buyMeCart', 'true');
    $(".product-form--atc .product-form--atc-button").click()
  })

  // buy now 点击
  $(".buyMe .buyNow button").click(function(){
    const variantId = $('variant-selection').attr('variant'); // 替换为实际的变体ID
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId, // 替换为产品的 Variant ID
              quantity: 1
            }
          ]
        })
      });
    })
    .then(() => {
      // 跳转到结账页面
      window.location.href = '/checkout?utm_source=product_page&utm_medium=bottom_cta';
    })
    .catch(error => {
      console.error('Error:', error);
    });
  })

});

/* stamped review sroll */
document.addEventListener('DOMContentLoaded', () => {
  const rating = document.querySelector('.stamped-product-reviews-badge');
  const target = document.querySelector('#stamped-main-widget');
  if (rating && target) {
    rating.addEventListener('click', e => {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});
/* stamped review sroll end*/